export const fiveSteps = [
  {
    id: 1,
    title: 'Выберите<br>вакансию',
    text: 'Компания постоянно растет, а с ней расширяется и список вакансий.'
  },
  {
    id: 2,
    title: 'Отправьте<br>резюме',
    text: 'Расскажите нам о своём образовании и опыте работы.'
  },
  {
    id: 3,
    title: `Пообщайтесь<br>с HR`,
    text: 'Личный разговор покажет, насколько хорошо мы подходим вам, а вы — нам.'
  },
  {
    id: 4,
    title: 'Пройдите<br>тестирование',
    text: 'Проверим навыки коммуникации и когнитивные способности.'
  },
  {
    id: 5,
    title: 'Познакомьтесь <br> с&nbsp;руководителем',
    text: 'Узнайте, насколько комфортно вам будет работать друг с другом.'
  }
]
